<script lang="ts">
  const GOOGLE_MAPS_API_KEY = "AIzaSyCxTYoLc2kAwV3DqRh_FYi-s1g8WEtbzYg";

  export let address: string = "";
  export let size: string = "380x164"

  function getMapUrl(address: string) {
    return address && address.trim().length > 0
      ? `https://maps.googleapis.com/maps/api/staticmap?center=${encodeURI(
          address
        )}&key=${GOOGLE_MAPS_API_KEY}&size=${size}&maptype=roadmap&markers=color:red%7C${encodeURI(address)}`
      : "";
  }

  $: backgroundMap = `background-image: url(${getMapUrl(address)});`;
</script>

<div style={backgroundMap} class="absolute inset-0 flex items-center justify-center bg-center bg-no-repeat bg-cover">
  {#if !address || !address.trim()}
  <div class="flex flex-col items-center">
    <i class="mb-1.5 text-gray-600 material-icons">map</i>
    <p class="text-gray-600 text-12">No map preview</p>
  </div>
  {/if}
</div>
